import { RelatedProducts } from "./components/RelatedProducts";
import { SearchButton } from "./components/SearchButton";
import { SearchResults } from "./components/SearchResults";
import { SelectMenu } from "./components/SelectMenu";
import { useTransformCategories } from "./hooks/useTransformCategories";

const defaultPageConfig = {
	searchLabel: "Search Products",
	category: "",
	showInlineResults: false,
};

const pageConfigs = {
	"/cinch-covers/": {
		searchLabel: "Search Cinch Covers",
		category: "Cinch Covers",
		parent: "Boat Covers",
		showInlineResults: true,
	},
	"/cinch-covers-test/": {
		searchLabel: "Search Cinch Covers",
		category: "Cinch Covers",
		parent: "Boat Covers",
		showInlineResults: true,
	},
	"/tower-down-ratchet-covers/": {
		searchLabel: "Search Covers",
		category: "Tower Down Ratchet Covers",
		parent: "Boat Covers",
		showInlineResults: true,
	},
	"/tower-down-ratchet-covers-test/": {
		searchLabel: "Search Covers",
		category: "Tower Down Ratchet Covers",
		parent: "Boat Covers",
		showInlineResults: true,
	},
	"/storage-covers/": {
		searchLabel: "Search Covers",
		category: "Double Up Storage Covers",
		parent: "Boat Covers",
		showInlineResults: true,
	},
	"/storage-cover-test/": {
		searchLabel: "Search Covers",
		category: "Double Up Storage Covers",
		parent: "Boat Covers",
		showInlineResults: true,
	},
	"/shade-sail/": {
		searchLabel: "Search Shade Sails",
		category: "Shade Sails",
		parent: "Shade",
		showInlineResults: true,
	},
	"/shade-sail-test/": {
		searchLabel: "Search Shade Sails",
		category: "Shade Sails",
		parent: "Shade",
		showInlineResults: true,
	},
	"/folding-canopy-top/": {
		searchLabel: "Search Folding Canopy Tops",
		category: "Folding Canopy Tops",
		parent: "Shade",
		showInlineResults: true,
	},
	"/folding-canopy-top-test/": {
		searchLabel: "Search Folding Canopy Tops",
		category: "Folding Canopy Tops",
		parent: "Shade",
		showInlineResults: true,
	},
	"/bimini-enclosure/": {
		searchLabel: "Search Bimini Tops",
		category: "Bimini Tops",
		parent: "Shade",
	},
	"/swim-platform-cover/": {
		searchLabel: "Search Swim Platform Covers",
		category: "Swim Platform Covers",
		parent: "Accessory Covers",
		showInlineResults: true,
	},
	"/swim-platform-covers/": {
		searchLabel: "Search Swim Platform Covers",
		category: "Swim Platform Covers",
		parent: "Accessory Covers",
		showInlineResults: true,
	},
	"/swim-platform-cover-test/": {
		searchLabel: "Search Swim Platform Covers",
		category: "Swim Platform Covers",
		parent: "Accessory Covers",
		showInlineResults: true,
	},
	"/speaker-covers/": {
		searchLabel: "Search Speaker Covers",
		category: "Speaker Covers",
		parent: "Accessory Covers",
	},
	"/board-rack-covers/": {
		searchLabel: "Search Board Rack Covers",
		category: "Board Rack Covers",
		parent: "Accessory Covers",
	},
	"/pole-guide-covers/": {
		searchLabel: "Search Pole Guide Covers",
		category: "Pole Guide Covers",
		parent: "Accessory Covers",
	},
};

function App() {
	let pathName = window.location.pathname;
	if (pathName.charAt(pathName.length - 1) !== "/") {
		pathName += "/";
	}
	const pageConfig = { ...defaultPageConfig, ...pageConfigs?.[pathName] };

	const categoryHidden = Boolean(pageConfig?.category);
	const transformCategories = useTransformCategories();
	return (
		<div className="isolate">
			<div className="bg-[#dd2c2c] xl:sticky top-0 z-10">
				<div
					className={`mx-auto max-w-[1430px]  px-[35px] grid sm:grid-cols-2 md:grid-cols-3  gap-6 text-white items-end ${
						categoryHidden ? "lg:grid-cols-6" : "lg:grid-cols-7"
					} ${pageConfig.showInlineResults ? "py-10" : "py-[20px]"}`}
				>
					<div className="anton text-xl sm:col-span-2  md:col-span-3 text-center lg:col-span-1 lg:text-right">
						{pageConfig?.searchLabel}
					</div>

					<SelectMenu
						label="Category"
						attribute="categoryArray"
						limit={50}
						facetOrdering={false}
						transformItems={transformCategories}
						defaultValue={pageConfig?.category}
					/>

					<SelectMenu
						attribute="Year"
						limit={50}
						filterBy="year"
						transformItems={(items) =>
							items.sort((a, b) => Number(b.value) - Number(a.value))
						}
						showOther
					/>
					<SelectMenu
						attribute="Make"
						limit={50}
						facetOrdering={false}
						showOther
					/>
					<SelectMenu
						attribute="Model"
						limit={50}
						facetOrdering={false}
						showOther
						filterBy="Model"
					/>
					<SelectMenu
						attribute="Tower"
						limit={50}
						facetOrdering={false}
						showOther
						filterBy="Tower"
					/>
					<SearchButton
						pageConfig={pageConfig}
						categoryHidden={categoryHidden}
					/>
				</div>
			</div>

			{pageConfig.showInlineResults && (
				<div className="mx-auto max-w-[1430px] py-[20px] px-[35px] animate-fade-slide-in">
					<SearchResults />
					<RelatedProducts />
				</div>
			)}
		</div>
	);
}

export default App;
